export default __webpack_public_path__ + "static/media/Addie.831d863e.jpg";